module.exports = __webpack_public_path__ + "img/yellow_square.fe1dc34e.png";